export default function SafetyWarning({ onStart }: { onStart: () => void }) {
  return (
    <div className="fixed inset-0 bg-gradient-to-b from-amber-100 to-orange-50 z-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-3xl max-w-sm w-full overflow-hidden shadow-2xl">
        {/* Header */}
        <div className="bg-gradient-to-r from-orange-500 to-amber-400 p-6 text-center text-white">
          <div className="text-6xl mb-3">⚠️</div>
          <h2 className="text-2xl font-extrabold">Cảnh báo An toàn!</h2>
          <p className="text-sm opacity-90 mt-1">Trước khi bắt đầu, hãy nhớ điều này nhé!</p>
        </div>

        {/* Safety rules */}
        <div className="p-5 space-y-3">
          <div className="flex items-start gap-3 p-3 bg-red-50 rounded-2xl">
            <span className="text-2xl flex-shrink-0">🔪</span>
            <p className="text-sm font-bold text-red-700">Không tự ý dùng dao.</p>
          </div>
          <div className="flex items-start gap-3 p-3 bg-orange-50 rounded-2xl">
            <span className="text-2xl flex-shrink-0">🔥</span>
            <p className="text-sm font-bold text-orange-700">Không tự ý nhóm lửa.</p>
          </div>
          <div className="flex items-start gap-3 p-3 bg-amber-50 rounded-2xl">
            <span className="text-2xl flex-shrink-0">👨‍👩‍👧</span>
            <p className="text-sm font-bold text-amber-700">Khi nấu ăn ngoài đời thật phải có người lớn giúp.</p>
          </div>
          <div className="flex items-start gap-3 p-3 bg-green-50 rounded-2xl">
            <span className="text-2xl flex-shrink-0">📚</span>
            <p className="text-sm font-bold text-green-700">Trò chơi này giúp các em học nấu ăn an toàn.</p>
          </div>
        </div>

        {/* Mascot & button */}
        <div className="px-5 pb-6 flex flex-col items-center gap-4">
          <div className="flex items-center gap-3 bg-amber-50 rounded-2xl px-4 py-3 w-full">
            <span className="text-3xl">🧒</span>
            <p className="text-xs font-semibold text-amber-700">"Mình sẽ luôn nhờ người lớn khi gặp việc nguy hiểm!"</p>
          </div>
          <button
            onClick={onStart}
            className="w-full py-4 bg-gradient-to-r from-orange-400 to-amber-400 text-white font-extrabold text-lg rounded-2xl cursor-pointer hover:opacity-90 transition-all whitespace-nowrap"
          >
            Tôi hiểu rồi! Bắt đầu chơi 🎋
          </button>
        </div>
      </div>
    </div>
  );
}
